import React from 'react';
import Hero from '../components/Hero';
import Navbar from '../components/Navbar';
import CountdownTimer from '../components/CountdownTimer';
import OurStory from '../components/OurStory';
import EventDetails from '../components/EventDetails';
import WeddingParty from '../components/WeddingParty';
import Gallery from '../components/Gallery';
import Footer from '../components/Footer';
export function MainSite() {
  return <div className="font-sans text-gray-800 bg-ivory" data-id="element-281">
      <Navbar data-id="element-282" />
      <Hero data-id="element-283" />
      <CountdownTimer data-id="element-284" />
      <OurStory data-id="element-285" />
      <EventDetails data-id="element-286" />
      <WeddingParty data-id="element-287" />
      <Gallery data-id="element-288" />
      <Footer data-id="element-289" />
    </div>;
}